import { useEffect, useState } from "react";
import { Reveal, SectionLabel } from "@/components/site/Reveal";
import { IMAGES } from "@/lib/content";
import { api } from "@/lib/api";

export const FishRoomSection = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/fishroom").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <section className="py-24 lg:py-32" data-testid="fishroom-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-8 items-center mb-14">
          <Reveal className="lg:col-span-7">
            <SectionLabel>The Fish Room</SectionLabel>
            <h2 className="mt-4 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
              FROM A FEW TANKS TO A FISH ROOM
            </h2>
            <p className="mt-5 text-brand-textSec leading-relaxed max-w-2xl">
              The first major physical project is building a rack in the office — consolidating the tanks
              scattered around the house and creating a proper foundation for breeding and growing the project.
              This gallery will fill up as construction and progress happen.
            </p>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-5">
            <div className="rounded-2xl overflow-hidden border border-white/5">
              <img src={IMAGES.fishroomMain} alt="Aquarium detail" className="w-full h-64 lg:h-72 object-cover" />
            </div>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, i) => (
            <Reveal key={item.id} delay={i * 0.08}>
              <div className="group card-surface overflow-hidden h-full" data-testid={`fishroom-card-${item.id}`}>
                <div className="relative aspect-[4/3] overflow-hidden">
                  {item.image ? (
                    <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  ) : (
                    <div className="w-full h-full bg-brand-elevated grid place-items-center text-brand-textMuted text-xs">Image coming soon</div>
                  )}
                  {item.stage && (
                    <span className="absolute top-3 left-3 text-[10px] uppercase tracking-wider bg-brand-base/70 backdrop-blur text-brand-cyan px-2.5 py-1 rounded-full">
                      {item.stage}
                    </span>
                  )}
                  {item.is_sample && (
                    <span className="absolute top-3 right-3 text-[10px] uppercase tracking-wider bg-brand-base/70 backdrop-blur text-brand-textSec px-2.5 py-1 rounded-full">
                      Sample
                    </span>
                  )}
                </div>
                <div className="p-5">
                  <h3 className="font-display font-semibold text-white">{item.title}</h3>
                  {item.caption && <p className="mt-1.5 text-brand-textSec text-sm leading-relaxed">{item.caption}</p>}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
